import { useRecoilState } from 'recoil';

import { useOnboardingState } from '@/context';
import { useErrorHandler } from '@/hooks';
import { verifyTermsAcceptanceService } from '@/services';

export const useVerifyTermsAcceptance = () => {
  const [state, setState] = useRecoilState(useOnboardingState);
  const errorHandler = useErrorHandler();

  const handleVerifyTermsAcceptance = (companyId: string) => {
    if (state.loading || state.loaded) return;

    setState((old) => ({ ...old, loading: true }));
    verifyTermsAcceptanceService(companyId)
      .then((termsHasBeenAccepted) => setState((old) => ({ ...old, termsHasBeenAccepted, loaded: true })))
      .catch(errorHandler)
      .finally(() => setState((old) => ({ ...old, loading: false })));
  };

  return { handleVerifyTermsAcceptance, selfOnboardingState: state };
};
